import { render, staticRenderFns } from "./FideicomisoForm.vue?vue&type=template&id=3efa063b&scoped=true"
import script from "./FideicomisoForm.vue?vue&type=script&lang=js"
export * from "./FideicomisoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efa063b",
  null
  
)

export default component.exports